export default __webpack_public_path__ + "static/blue-cbccf5027ba9c4a33b4bca998c81bddf.svg";